import * as React from 'react';
import { Component } from 'react';
import { observer } from 'mobx-react';
import { withTheme } from 'styled-components';
import Icon from './Icon';

interface ChangeIndicatorIconProps {
    theme?: { [property: string]: string | number };
    filename: string;
    changeTheme: string | number;
}

const iconStyleProps = {
    display: 'inline-block',
    verticalAlign: 'middle',
};

@observer
class ChangeIndicatorIcon extends Component<ChangeIndicatorIconProps> {
    render() {
        const { theme, filename, changeTheme } = this.props;
        return (
            <Icon
                fileName={filename}
                {...changeTheme}
                {...iconStyleProps}
                {...theme.ChangeIcon}
            />
        );
    }
}

export default withTheme(ChangeIndicatorIcon);



// WEBPACK FOOTER //
// ./src/Components/ChangeIndicatorIcon.tsx